import styled from "styled-components";
import {Collapse} from "antd";

export const StyledCollapse = styled(Collapse)`
  border: 0;
  background-color: transparent;
  
  .ant-collapse-item{
    //border: 1px solid var(--c-line);
    //border-radius: 4px !important;
    margin-bottom: 0;
    
    &.ant-collapse-item-active{
      .ant-collapse-header{

        .ant-collapse-expand-icon{
          .anticon{
            transform: rotate(180deg);
          }
        }
      }
    }
    
    .ant-collapse-header{
      flex-direction: row-reverse;
      
      .ant-collapse-expand-icon{
        padding-inline-end: 0;
        padding-inline-start: 12px;
        
        .anticon{
          transform: rotate(90deg);
        }
      }
    }
  }

`
